<template>
    <ListItemButton
        v-if="isPromoteAppEnabled"
        icon-name="cloud-arrow-down"
        dusk="OfflineAccessButton"
        @click="openPromoteApp"
    >
        <span>
            {{ localizations[lang].tooltips.download }}
        </span>
    </ListItemButton>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ListItemButton from '../Components/list/ListItemButton.vue';

export default {
    components: { ListItemButton },
    props: {
        width: {
            type: String,
            default: '18px',
        },
        height: {
            type: String,
            default: '18px',
        },
    },
    computed: {
        ...mapState(['localizations', 'lang', 'embeddedInMobileApp', 'promoteApp']),
        ...mapGetters(['isPromoteAppEnabled']),
    },
    methods: {
        ...mapMutations(['openPromoteApp']),
    },
};
</script>
